import Vue from "vue";
import { store } from "../store/store.js";

Vue.filter("persianDigit", (value) => {
  if (store.getters.getAppLang === "en") {
    return value;
  } else {
    let str = value + "";
    return str
      .split("0")
      .join("۰")
      .split("1")
      .join("۱")
      .split("2")
      .join("۲")
      .split("3")
      .join("۳")
      .split("4")
      .join("۴")
      .split("5")
      .join("۵")
      .split("6")
      .join("۶")
      .split("7")
      .join("۷")
      .split("8")
      .join("۸")
      .split("9")
      .join("۹");
  }
});
Vue.filter("englishDigits", (value) => {
  let str = value + "";
  return str
    .split("۰")
    .join("0")
    .split("۱")
    .join("1")
    .split("۲")
    .join("2")
    .split("۳")
    .join("3")
    .split("۴")
    .join("4")
    .split("۵")
    .join("5")
    .split("۶")
    .join("6")
    .split("۷")
    .join("7")
    .split("۸")
    .join("8")
    .split("۹")
    .join("9");
});

Vue.filter("commaSep", (value) => {
  return value ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "";
});
Vue.filter("creditCardSep", (value) => {
  return value.toString().replace(/\B(?=(\d{4})+(?!\d))/g, " ");
});
Vue.filter("dashSep", (value) => {
  return value.toString().replace(/\B(?=(\d{4})+(?!\d))/g, "-");
});
Vue.filter("formatTime", function (value, persianTimer) {
  let hours = parseInt((value % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  let minutes = parseInt((value % (1000 * 60 * 60)) / (1000 * 60));
  let seconds = parseInt((value % (1000 * 60)) / 1000);

  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  if (seconds < 10) {
    seconds = "0" + seconds;
  }

  if (persianTimer)
    return (
      hours +
      " " +
      Vue.prototype.$translate("hoursAnd") +
      " " +
      minutes +
      " " +
      Vue.prototype.$translate("minutesAnd") +
      " " +
      seconds +
      " " +
      Vue.prototype.$translate("second")
    );
  else return `${minutes}:${seconds}`;
});
